__turbopack_context__.v({
  "bottomNote": "Optimize-module__lnOV-W__bottomNote",
  "bottomNoteBar": "Optimize-module__lnOV-W__bottomNoteBar",
  "content": "Optimize-module__lnOV-W__content",
  "heroBuyNowButton": "Optimize-module__lnOV-W__heroBuyNowButton",
  "overlay": "Optimize-module__lnOV-W__overlay",
  "placeholder": "Optimize-module__lnOV-W__placeholder",
  "section": "Optimize-module__lnOV-W__section",
  "separator": "Optimize-module__lnOV-W__separator",
  "stack": "Optimize-module__lnOV-W__stack",
  "title": "Optimize-module__lnOV-W__title",
  "visual": "Optimize-module__lnOV-W__visual",
});
